import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import cn from "classnames";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Controller} from "react-hook-form";

function DatePickerComponent({
  dateFormat = "dd/MM/yyyy",
  maxDate,
  minDate,
  control,
  errors,
  rules,
  name,
}) {
  return (
    <div
      className={cn("form-control form-date-range-picker", {
        "form-date-range-picker--error": errors && errors[`${name}`],
      })}
    >
      <Controller
        render={({ field }) => (
          <DatePicker
            {...field}
            selected={field.value}
            onChange={(date) => field.onChange(date?.valueOf() ?? null)}
            selectsStart
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat={dateFormat}
            maxDate={maxDate}
            minDate={minDate}
          />
        )}
        name={`${name}`}
        control={control}
        rules={rules ?? {}}
      />
      <span className="form-group-suffix">
        <FontAwesomeIcon icon={faCalendarAlt} />
      </span>
    </div>
  );
}

export default DatePickerComponent;
